import { render, staticRenderFns } from "./AppNumberLink.vue?vue&type=template&id=85b2102c&"
import script from "./AppNumberLink.vue?vue&type=script&lang=js&"
export * from "./AppNumberLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports